"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expatLongTerm_enDe = void 0;
exports.expatLongTerm_enDe = {
    metaData: {
        prismicId: 'ZsNlTxIAACwAgq5j',
        type: 'comparisontable',
        uid: 'expat-long-term',
        lang: 'en-de',
        lastPublished: '2024-09-30T12:46:53+0000',
    },
    tableData: {
        title: 'Expat long-term',
        collapsibleSections: false,
        hideDetails: false,
        tableData: [
            {
                section: {
                    title: '',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$062a6b78-3e8a-4459-a498-ba74b69910de_header',
                            text: 'Choose a plan',
                            description: null,
                        },
                        {
                            cellId: 'table_row$062a6b78-3e8a-4459-a498-ba74b69910de_0',
                            type: 'BUTTON',
                            buttonCaption: 'Basic',
                            disabled: true,
                        },
                        {
                            cellId: 'table_row$062a6b78-3e8a-4459-a498-ba74b69910de_1',
                            type: 'BUTTON',
                            buttonCaption: 'Premium',
                            disabled: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$c0843b08-11a4-4cf6-b2b6-2a9c23f3d1e9_header',
                            text: 'Monthly price',
                            description: null,
                        },
                        {
                            cellId: 'table_row$c0843b08-11a4-4cf6-b2b6-2a9c23f3d1e9_0',
                            text: '€ —',
                            fontVariant: 'PRICE',
                        },
                        {
                            cellId: 'table_row$c0843b08-11a4-4cf6-b2b6-2a9c23f3d1e9_1',
                            text: '€ —',
                            fontVariant: 'PRICE',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$624f34fd-f2b7-494f-9af1-2164d8c5d2d2_header',
                            text: 'Overall limit',
                            description: null,
                        },
                        {
                            cellId: 'table_row$624f34fd-f2b7-494f-9af1-2164d8c5d2d2_0',
                            text: 'Up to €1.5million',
                        },
                        {
                            cellId: 'table_row$624f34fd-f2b7-494f-9af1-2164d8c5d2d2_1',
                            text: 'Up to €1.5million',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$41a26b6c-4e50-403d-98e8-1b1b77a9e671_header',
                            text: 'Worldwide coverage',
                            description: 'Excluding the US & Caribbean.',
                        },
                        {
                            cellId: 'table_row$41a26b6c-4e50-403d-98e8-1b1b77a9e671_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$41a26b6c-4e50-403d-98e8-1b1b77a9e671_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$9a2f6539-a9b6-44b3-b7fc-4c95e5cc29ea_header',
                            text: 'Coverage for the US & Caribbean',
                            description: null,
                        },
                        {
                            cellId: 'table_row$9a2f6539-a9b6-44b3-b7fc-4c95e5cc29ea_0',
                            text: 'Available as an add-on',
                        },
                        {
                            cellId: 'table_row$9a2f6539-a9b6-44b3-b7fc-4c95e5cc29ea_1',
                            text: 'Available as an add-on',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a456c87b-357c-42d6-aee2-6ba154b40b6b_header',
                            text: 'Pre-existing conditions',
                            description: 'Any treatments related to pre-existing conditions',
                        },
                        {
                            cellId: 'table_row$a456c87b-357c-42d6-aee2-6ba154b40b6b_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$a456c87b-357c-42d6-aee2-6ba154b40b6b_1',
                            checkmarkValue: false,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'General',
                    icon: 'https://images.prismic.io/feather-website/ZqEU1B5LeNNTxdoH_heart.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$f30b3479-795f-4626-b9a4-f3478294f14d_header',
                            text: 'General doctors’ visits',
                            description: null,
                        },
                        {
                            cellId: 'table_row$f30b3479-795f-4626-b9a4-f3478294f14d_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$f30b3479-795f-4626-b9a4-f3478294f14d_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$7679f63d-2872-4b86-a21c-13247c3e4c45_header',
                            text: 'Specialists',
                            description: null,
                        },
                        {
                            cellId: 'table_row$7679f63d-2872-4b86-a21c-13247c3e4c45_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$7679f63d-2872-4b86-a21c-13247c3e4c45_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$64a725fb-8b79-4ef4-8d6e-71238b595d87_header',
                            text: 'Medication',
                            description: null,
                        },
                        {
                            cellId: 'table_row$64a725fb-8b79-4ef4-8d6e-71238b595d87_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$64a725fb-8b79-4ef4-8d6e-71238b595d87_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$180a8169-9eef-4077-8d48-e7392fd334e0_header',
                            text: 'Diagnostic tests and scans',
                            description: 'E.g. x-rays, blood tests, pathology tests, MRI, CT, PET scans',
                        },
                        {
                            cellId: 'table_row$180a8169-9eef-4077-8d48-e7392fd334e0_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$180a8169-9eef-4077-8d48-e7392fd334e0_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$003b73ab-2902-410c-bdf5-264c3b039634_header',
                            text: 'Vaccinations',
                            description: 'For children or for travel purposes',
                        },
                        {
                            cellId: 'table_row$003b73ab-2902-410c-bdf5-264c3b039634_0',
                            text: '€300',
                        },
                        {
                            cellId: 'table_row$003b73ab-2902-410c-bdf5-264c3b039634_1',
                            text: '€300',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$a0bb8956-c778-4fa8-accf-d8f710c8795d_header',
                            text: 'Psychiatric therapies',
                            description: 'E.g. counselling, cognitive behavioural therapy and psychotherapy',
                        },
                        {
                            cellId: 'table_row$a0bb8956-c778-4fa8-accf-d8f710c8795d_0',
                            text: '€1,500',
                        },
                        {
                            cellId: 'table_row$a0bb8956-c778-4fa8-accf-d8f710c8795d_1',
                            text: '€3,000',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6cff056b-909a-4f1c-9a15-bab21d31194d_header',
                            text: 'Routine check ups',
                            description: 'available after 1 year',
                        },
                        {
                            cellId: 'table_row$6cff056b-909a-4f1c-9a15-bab21d31194d_0',
                            text: '€450',
                        },
                        {
                            cellId: 'table_row$6cff056b-909a-4f1c-9a15-bab21d31194d_1',
                            text: '€750',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$63ed6c2c-8a9d-4c25-985d-13bfc9554666_header',
                            text: 'Access to licensed doctors worldwide by phone for non-emergency conditions.',
                            description: null,
                        },
                        {
                            cellId: 'table_row$63ed6c2c-8a9d-4c25-985d-13bfc9554666_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$63ed6c2c-8a9d-4c25-985d-13bfc9554666_1',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Hospital',
                    icon: 'https://images.prismic.io/feather-website/ZqEUqx5LeNNTxdoD_hospital-building.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$eeaa8c81-25b0-4459-918d-9931eedab7f2_header',
                            text: 'Overnight stay',
                            description: 'E.g. accommodation, meals and medical treatment',
                        },
                        {
                            cellId: 'table_row$eeaa8c81-25b0-4459-918d-9931eedab7f2_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$eeaa8c81-25b0-4459-918d-9931eedab7f2_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$0223b663-8d85-495e-8720-ec0cc0e7fab9_header',
                            text: 'Accident and emergency room treatment',
                            description: null,
                        },
                        {
                            cellId: 'table_row$0223b663-8d85-495e-8720-ec0cc0e7fab9_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$0223b663-8d85-495e-8720-ec0cc0e7fab9_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$cc7907c5-1f56-4c53-9d6f-2bc8a22c7782_header',
                            text: 'Ambulance services',
                            description: null,
                        },
                        {
                            cellId: 'table_row$cc7907c5-1f56-4c53-9d6f-2bc8a22c7782_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$cc7907c5-1f56-4c53-9d6f-2bc8a22c7782_1',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Dental',
                    icon: 'https://images.prismic.io/feather-website/ZqEU8x5LeNNTxdoK_dental-tooth-teeth.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$496b38d2-9af4-461d-8b79-fed377486c13_header',
                            text: 'Dental treatment following an accident',
                            description: null,
                        },
                        {
                            cellId: 'table_row$496b38d2-9af4-461d-8b79-fed377486c13_0',
                            checkmarkValue: true,
                        },
                        {
                            cellId: 'table_row$496b38d2-9af4-461d-8b79-fed377486c13_1',
                            checkmarkValue: true,
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$42cce2d6-c0c6-4605-bc80-cb9825b45afa_header',
                            text: 'Routine dental treatment',
                            description: 'Available after 6 months of coverage',
                        },
                        {
                            cellId: 'table_row$42cce2d6-c0c6-4605-bc80-cb9825b45afa_0',
                            text: '€750',
                        },
                        {
                            cellId: 'table_row$42cce2d6-c0c6-4605-bc80-cb9825b45afa_1',
                            text: '€1,125',
                        },
                    ],
                ],
            },
            {
                section: {
                    title: 'Pregnancy and childbirth',
                    icon: 'https://images.prismic.io/feather-website/ZqEUrh5LeNNTxdoG_family.png?auto=format,compress',
                },
                rows: [
                    [
                        {
                            cellId: 'table_row$2db677a7-227b-4655-927a-30db297c8497_header',
                            text: 'Normal pregnancy and childbirth',
                            description: 'Available after 18 months of coverage',
                        },
                        {
                            cellId: 'table_row$2db677a7-227b-4655-927a-30db297c8497_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$2db677a7-227b-4655-927a-30db297c8497_1',
                            text: '€9,000',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$56ae80a3-98ad-4933-9c68-ebdc92bad47c_header',
                            text: 'Complicated pregnancy and childbirth',
                            description: 'Available after 18 months of coverage',
                        },
                        {
                            cellId: 'table_row$56ae80a3-98ad-4933-9c68-ebdc92bad47c_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$56ae80a3-98ad-4933-9c68-ebdc92bad47c_1',
                            text: '€18,000',
                        },
                    ],
                    [
                        {
                            cellId: 'table_row$6b2c3e6c-1f4c-4375-bbe4-220d79d99134_header',
                            text: 'Pregnancy complications',
                            description: 'Available after 18 months of coverage',
                        },
                        {
                            cellId: 'table_row$6b2c3e6c-1f4c-4375-bbe4-220d79d99134_0',
                            checkmarkValue: false,
                        },
                        {
                            cellId: 'table_row$6b2c3e6c-1f4c-4375-bbe4-220d79d99134_1',
                            checkmarkValue: true,
                        },
                    ],
                ],
            },
        ],
    },
};
